function isMobile() {
  // Simple check for mobile devices, you might need a more robust detection
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function checkScreenSize() {
  if (isMobile()) return; // Do nothing on mobile devices

  const row = document.querySelector('.row');
  const heroContent = document.querySelector('.wrap.hero_content');
  const heroMedia = document.querySelector('.hero-media');
  const heroMediaWrap = document.querySelector('.wrap.hero_media');

  if (window.innerWidth >= 992) {
    if (!heroMediaWrap.classList.contains('has-media')) {
      heroMediaWrap.appendChild(heroMedia);
      heroMediaWrap.classList.add('has-media');
      heroContent.classList.remove('has-media');
      heroContent.classList.add('no-media');
    }
  } else {
    if (heroMediaWrap.classList.contains('has-media')) {
      heroContent.insertBefore(heroMedia, heroContent.firstChild);
      heroMediaWrap.classList.remove('has-media');
      heroContent.classList.remove('no-media');
      heroContent.classList.add('has-media');
    }
  }
}

window.addEventListener('load', function() {
  checkScreenSize();
});

window.addEventListener('resize', function() {
  checkScreenSize();
});

const siteBanner = document.querySelector('.site_banner');

function handleScroll() {
  const bannerRect = siteBanner.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > bannerRect.top) { 
    siteBanner.classList.add('sticky');
  } else {
    siteBanner.classList.remove('sticky');
  }
}

window.addEventListener('scroll', handleScroll);